(function () {
    'use strict';

    angular
        .module('app')
        .controller('localViewerOptions', localViewerOptions);

    localViewerOptions.$inject = ['localViewerOptionsService', '$mdDialog', '$filter', 'loginService'];

    function localViewerOptions(localViewerOptionsService, $mdDialog, $filter, loginService) {
        var vm = this;

        vm.localViewerOptionsLabel = loginService.resourceStrings["LOCAL_VIEWER_OPTIONS"]; // "Local Viewer Options"
        vm.localViewerOptionsDetailLabel = loginService.resourceStrings["LOCAL_VIEWER_OPTIONS_DETAIL"]; // "Configure File Extensions that use the Local Viewer."
        vm.labelLocalExtensions = loginService.resourceStrings["ADMIN_LOCAL_VIEWER_DOCS_VIEWED_WITH_VIEWER_EXCEPT"]; // "All documents will be viewed with Adept Viewer, except for documents with the following file extensions, which will be viewed with the associated Windows file type.";
        vm.labelLocal = loginService.resourceStrings["ADMIN_LOCAL_HEADING_LOCAL"]; // "All documents will be viewed with Adept Viewer, except for documents with the following file extensions, which will be viewed with the associated Windows file type.";
        vm.labelAutovue = loginService.resourceStrings["ADMIN_LOCAL_HEADING_VIEWER_ONLY"]; // "All documents will be viewed with Adept Viewer, except for documents with the following file extensions, which will be viewed with the associated Windows file type.";
        vm.showRenderPdfMenuText = loginService.resourceStrings["VIEW_SHOW_RENDER_PDF_MENU"]; // "View (Render PDF)" option is ON"

        vm.okLabel = loginService.resourceStrings["OK"]; // "OK"
        vm.cancelLabel = loginService.resourceStrings["CANCEL"]; // "Cancel"
        //vm.showViewRenderPdfMenu = false;// This is what is saved in the database settings, loaded in activate(), and saved in onOK().
        vm.extString = "";

        activate();

        //when the ok button is clicked
        vm.onOk = function () {
            // Object used to get and set the viewer options in the WebAPI
            var viewerOptions = {
                ViewerType: vm.viewWith,
                LocalViewerExtensions: vm.extString,
                ShowViewRenderPdfMenu: vm.showViewRenderPdfMenu
            };

            localViewerOptionsService.setLocalViewerSettings(viewerOptions).then(function () {
                $mdDialog.hide();
            })
        }

        //when the cancel button is clicked
        vm.onCancel = function () {
            $mdDialog.cancel();
        }

        function activate() {
            vm.localViewerOptionsService = localViewerOptionsService;
            vm.loadingDataLabel = loginService.resourceStrings["LOADING_DATA"]; // "Loading Data"

            localViewerOptionsService.getLocalViewerSettings().then(function (data) {
                if (data != null) {
                    vm.viewWith = data.ViewerType;
                    vm.extString = data.LocalViewerExtensions;
                    vm.showViewRenderPdfMenu = data.ShowViewRenderPdfMenu;
                }
            });

        }
    }
})();
